import { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import { Box, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { getAllEmployee } from "./employee_halper";
import EmployeeDetails from "./employee_details";
import Loading1 from "../frames/loading1";
import NewEmployee from "./new_employee";
import SalaryPayment from "./salary_payment";
import { formatIndianPhone } from "../client/client_halper";
import { useNavigate } from "react-router-dom";

function EmployeeList() {
    const [employeeList, setEmployeeList] = useState(null);
    const [allEmployee, setAllEmployee] = useState(null);
    const [activeEmployee, setActiveEmployee] = useState(null);
    const [activeFunction, setActiveFunction] = useState(null);
    const navigator = useNavigate();

    const initData = async (auth) => {
        if (!auth) return;
        const emp = await getAllEmployee()
        setEmployeeList(emp);
        setAllEmployee(emp);
    }

    const handleClose = () => {
        setActiveEmployee(null);
    };

    const changeActiveFunction = (value) => {
        setActiveFunction(value);
    }

    const clearFunction = () => {
        setActiveFunction(null);
    }

    const searchEmployee = (event) => {
        setEmployeeList(allEmployee.filter((itm) =>
            itm.name.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
            itm.designation.toLowerCase().startsWith(event.target.value.toLowerCase()) ||
            String(itm.phone).startsWith(event.target.value)
        ));
    }

    return (
        <MenuFrame permission="EMPLOYEE" screen="EMPLOYEE_LIST" onInit={initData} onSearch={searchEmployee}>
            <EmployeeDetails data={activeEmployee} handleClose={handleClose} />
            <NewEmployee open={activeFunction === "new-employee"} onClose={clearFunction} />
            <SalaryPayment open={activeFunction === "salary"} onClose={clearFunction} employee={allEmployee} />

            <Box sx={{ py: 2 }}>
                <Chip label="New Employee" variant="filled" color="info" onClick={() => { changeActiveFunction("new-employee"); }} style={{ margin: "0px 5px", textTransform: "none" }} />
                <Chip label="Salary Payment" variant="filled" color="info" onClick={() => { changeActiveFunction("salary"); }} style={{ margin: "0px 5px", textTransform: "none" }} />
                <Chip label="Salary Slip" variant="filled" color="info" onClick={() => { navigator("salary-slip"); }} style={{ margin: "0px 5px", textTransform: "none" }} />
                <Chip label="Month Wise Report" variant="filled" color="error" onClick={() => { changeActiveFunction("employee-salary"); }} style={{ margin: "0px 5px", textTransform: "none" }} />
            </Box>

            {employeeList === null ? <Loading1 /> :
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="List of all employee" className="nowrap">
                        <TableHead>
                            <TableRow sx={{ '&:last-child td, &:last-child th': { fontWeight: "bold" } }}>
                                <TableCell>ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Designation</TableCell>
                                <TableCell>Joining</TableCell>
                                <TableCell align="right">Phone</TableCell>
                                <TableCell>Mail</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {employeeList.map((row) => (
                                <TableRow
                                    key={row.account}
                                    onClick={(e) => { setActiveEmployee(row); }}
                                >
                                    <TableCell>{row.user_id}</TableCell>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.designation}</TableCell>
                                    <TableCell><div className="align_text">{row.doj} {row.doe !== null ? <ErrorOutlineOutlinedIcon color="warning" fontSize="small" titleAccess="This employee exit the orgnization." /> : ""}</div></TableCell>
                                    <TableCell align="right">{formatIndianPhone(row.phone)}</TableCell>
                                    <TableCell>{row.email}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </MenuFrame>
    );
}

export default EmployeeList;
